import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";
import { Box, FormLabel, IconButton, Typography } from "@mui/material";
import { useState } from "react";
export const FileUploadPreview = ({ onChange, label = "Upload File", initialPreview, }) => {
    const maxSizeInMB = 2.5;
    const [preview, setPreview] = useState(initialPreview ?? null);
    const [fileName, setFileName] = useState(null);
    const [error, setError] = useState(null);
    const handleFileChange = (e) => {
        const file = e.target.files?.[0] || null;
        if (file) {
            const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
            if (file.size > maxSizeInBytes) {
                setError(`File size exceeds ${maxSizeInMB} MB limit.`);
                setPreview(null);
                setFileName(null);
                onChange(undefined); // Clear the form value
                return;
            }
            const reader = new FileReader();
            reader.onload = () => {
                setPreview(reader.result); // Base64 for preview
                setFileName(file.name);
                const base64String = reader.result;
                onChange(base64String);
                setError(null);
            };
            reader.readAsDataURL(file);
        }
        else {
            setPreview(null);
            setFileName(null);
            onChange(undefined);
            setError(null);
        }
    };
    const handleRemove = () => {
        setPreview(null);
        setFileName(null);
        // Explicit null (not undefined) so the field is sent as null and the
        // server actually clears the saved image, rather than being omitted.
        onChange(null);
        setError(null);
    };
    return (_jsxs(Box, { mt: 2, position: "relative", children: [_jsx(FormLabel, { htmlFor: "file-upload", style: {
                    position: "absolute",
                    top: "-10px",
                    left: "12px",
                    backgroundColor: "white",
                    padding: "0 4px",
                    zIndex: 1,
                    fontSize: "0.75rem",
                }, children: label }), _jsx(Box, { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", p: 2, border: "1px solid grey", borderRadius: 2, position: "relative", bgcolor: "background.paper", children: preview ? (_jsxs(_Fragment, { children: [_jsx("img", { src: preview, alt: "Preview", style: {
                                maxWidth: "150px",
                                maxHeight: "150px",
                                borderRadius: "8px",
                                marginBottom: "8px",
                            } }), _jsx(Typography, { variant: "body2", color: "textSecondary", children: fileName }), _jsx(IconButton, { onClick: handleRemove, color: "error", size: "small", "aria-label": "delete", style: { marginTop: "8px" }, children: _jsx(DeleteIcon, {}) })] })) : (_jsxs(_Fragment, { children: [_jsx(CloudUploadIcon, { fontSize: "large", color: "action" }), _jsx(Typography, { variant: "body2", color: "textSecondary", children: "Upload your logo (max file size: 5 MB)" }), _jsx("input", { type: "file", id: "file-upload", accept: "image/*", style: {
                                position: "absolute",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                opacity: 0,
                                cursor: "pointer",
                            }, onChange: handleFileChange })] })) }), error && (_jsx(Typography, { variant: "body2", color: "error", style: { marginTop: "8px" }, children: error }))] }));
};
